var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"spinner-wrapper"}},[(_vm.loading)?_c('div',{staticClass:"spinner"}):_c('div',{staticClass:"check"},[_vm._v("✔")])])
}
var staticRenderFns = []

export { render, staticRenderFns }